export class ConfirmNote {
  note: string;
  title: string;
  message: string;
}
